













import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { ColorsList } from '../utils';

@Component
export default class LoadingIndicator extends Vue {
    @Prop({ default: ColorsList.black}) textColor: string;
    @Prop({ default: 'Cargando...'}) loadingText: string;
    @Prop({ default: 'primary'}) loadingColor: string;
}
